import IconText from '../../packages/kiti/components/presentation/IconText'
import React from 'react'
import { useNotification } from '@btime/react-messager'

const TextCopy = ({ label, value, size, ...props }) => {
  const notity = useNotification()

  return (
    <IconText
      label={label}
      size={size}
      iconRight="BsSubtract"
      iconSize="0.8rem"
      gap={0.4}
      onClick={e => {
        e.stopPropagation()
        navigator.clipboard
          .writeText(value)
          .then(() => notity.success({ title: 'Copiado com sucesso!' }))
          .catch(() => notity.error({ title: 'Falha ao copiar' }))
      }}
      {...props}
    />
  )
}

export default TextCopy
